export const ACCOUNTING_REFERENCE_DETAILS_SORT_BY = [
  'accref_name',
  'assigned_delivery_notes_count',
  'is_active',
  'signature_rate',
  'signed_delivery_notes_count',
  'unsigned_delivery_notes_count',
] as const;

export const ACCOUNTING_REFERENCE_DETAILS_SIGNATURE_FILTER = [
  'all',
  'signed',
  'unsigned',
] as const;
